// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2gkie","dragIcon":"SortableItem_dragIcon__Wbb0V","disabled":"SortableItem_disabled__11CL8"};